$(document).ready(function () {
    $('.accordion').on('show.bs.collapse', function () {
        $("body").autoHeightItems();
    });
    $('.accordion').on('shown.bs.collapse', function () {
        $("body").autoHeightItems();
    });
});